import { FC } from 'react';

import { Box, CloseButton, Group, Stack, Text } from '@mantine/core';
import { ContextModalProps } from '@mantine/modals';

import { InvitableCompanyList } from '@diagram/components/invitable-company-list/InvitableCompanyList';
import { useChatChannelAccess } from '@diagram/hooks/use-chat-channel-access';
import { ChatService } from '@diagram/services/ChatService';

import { CompanyProfile, DiagramChatChannel } from 'models';

import { ModalTitle } from 'components/modals/ModalTitle';

const InviteCompany: FC<ContextModalProps<{ channel: DiagramChatChannel }>> = ({ context, id, innerProps }) => {
    const { channel } = innerProps;
    const { companyIds } = useChatChannelAccess(channel);

    const invite = (company: CompanyProfile) => {
        context.closeModal(id);
        ChatService.addCompanyToChannel(channel, company).then();
    };

    return (
        <Stack gap="md">
            <Group justify="space-between" align="flex-start" wrap="nowrap">
                <Box miw={0}>
                    <ModalTitle align="left">Invite a company</ModalTitle>
                    <Text fz="sm" c="dimmed" mt={2}>
                        They join <strong>#{channel.name}</strong> and get access to your design.
                    </Text>
                </Box>
                <CloseButton onClick={() => context.closeModal(id)} />
            </Group>

            <InvitableCompanyList onSelect={invite} excludeIds={companyIds} />
        </Stack>
    );
};

export { InviteCompany };
